import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/core/models/api-response.model';
import { CargoEmpresa, PageResponse } from 'src/app/pages/empresa/pages/cargos/models/cargo.model';
import { unwrapConteudo } from '../utils/api.utils';

@Injectable({
  providedIn: 'root'
})
export class CargosApiService {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  listar(page: number, size: number, nome?: string): Observable<PageResponse<CargoEmpresa>> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (nome?.trim()) {
      params = params.set('nome', nome.trim());
    }

    return this.http.get<PageResponse<CargoEmpresa>>(`${this.baseUrl}/api/v1/cargos`, { params })
      .pipe(map((response) => this.normalizePage(response, size)));
  }

  criar(nome: string): Observable<CargoEmpresa> {
    const payload = { nome: nome.trim() };
    return this.http.post<ApiResponse<CargoEmpresa>>(`${this.baseUrl}/api/v1/cargos`, payload)
      .pipe(map((res) => this.normalizeCargo(unwrapConteudo(res))));
  }

  editar(id: number, payload: { nome: string; status: 'ATIVO' | 'INATIVO' }): Observable<CargoEmpresa> {
    const body = {
      nome: payload.nome.trim(),
      status: payload.status
    };
    return this.http.put<ApiResponse<CargoEmpresa>>(`${this.baseUrl}/api/v1/cargos/${id}`, body)
      .pipe(map((res) => this.normalizeCargo(unwrapConteudo(res))));
  }

  excluir(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/api/v1/cargos/${id}`);
  }

  private normalizeCargo(cargo: CargoEmpresa): CargoEmpresa {
    return {
      ...cargo,
      emUso: cargo.emUso ?? 0
    };
  }

  private normalizePage(response: PageResponse<CargoEmpresa>, fallbackSize: number): PageResponse<CargoEmpresa> {
    return {
      ...response,
      size: response.size ?? fallbackSize,
      content: (response.content ?? []).map((c) => this.normalizeCargo(c))
    };
  }

}
